"use strict";

var equalHeight = function equalHeight() {
  var equalHeightContainer = document.querySelectorAll('[data-equal-height]');

  var _loop = function _loop(i) {
    var allHeights = [];
    var equalHeightChildren = makeArray(equalHeightContainer[i].children);
    var maxHeight = -1;
    equalHeightChildren.forEach(function (child) {
      allHeights.push(child.offsetHeight);
    });
    maxHeight = Math.max.apply(Math, allHeights);
    equalHeightChildren.forEach(function (child) {
      child.style.height = "".concat(maxHeight, "px");
    });
  };

  for (var i = 0; i < equalHeightContainer.length; i += 1) {
    _loop(i);
  }
};

equalHeight();